import React, { useRef, useState } from 'react'
import { Button, InterfaceCopyIcon, Tooltip, TooltipContent, TooltipTrigger } from '@grammarly/design-system'
import { FormattedMessage } from 'react-intl'

import { copyTooltipDismissTime } from '../constants'
import { useTool } from '../tool-context'

export const ToolCopyButton: React.FC = () => {
  const { outputTextToCopy, isLoading } = useTool()
  const [isTooltipOpen, setIsTooltipOpen] = useState(false)
  const toolTipDismissRef = useRef<NodeJS.Timeout | null>(null)

  if (outputTextToCopy === null || isLoading) {
    return null
  }

  const copyText = () => {
    if (toolTipDismissRef.current) {
      clearTimeout(toolTipDismissRef.current)
    }
    void navigator?.clipboard.writeText(outputTextToCopy)
    setIsTooltipOpen(true)
    toolTipDismissRef.current = setTimeout(() => setIsTooltipOpen(false), copyTooltipDismissTime)
  }

  return (
    <Tooltip open={isTooltipOpen} onOpenChange={setIsTooltipOpen}>
      <TooltipTrigger asChild>
        <Button variant="secondary" size="small" onClick={copyText} iconStart={InterfaceCopyIcon}>
          <FormattedMessage
            id="global.uiAction.copyText"
            description="Text for CTA that prompts user to copy text"
            defaultMessage="Copy text"
          />
        </Button>
      </TooltipTrigger>
      <TooltipContent root={null}>
        <FormattedMessage
          id="global.uiNotification.copied.short"
          description="Text that lets user know a value was copied to the clipboard"
          defaultMessage="Copied!"
        />
      </TooltipContent>
    </Tooltip>
  )
}
